var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTopArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#1E1E1E",
    fillOpacity: 0.04
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    stroke: "#1E1E1E",
    strokeOpacity: 0.27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7071 16.2929C28.3166 15.9024 27.6834 15.9024 27.2929 16.2929L20.9289 22.6569C20.5384 23.0474 20.5384 23.6805 20.9289 24.0711C21.3195 24.4616 21.9526 24.4616 22.3431 24.0711L28 18.4142L33.6569 24.0711C34.0474 24.4616 34.6805 24.4616 35.0711 24.0711C35.4616 23.6805 35.4616 23.0474 35.0711 22.6569L28.7071 16.2929ZM29 39L29 17L27 17L27 39L29 39Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTopArrowDark);
export default __webpack_public_path__ + "static/media/ic-top-arrow-dark.3e6e3f905ae76daab4bca64fa2f350b7.svg";
export { ForwardRef as ReactComponent };